import { formGroupMessagesComponentModule } from '../form-group-messages/form-group-messages';

/*====================
 * 2023-01-10 - Phil DeJarnett
 * NOTE: This module has been stripped down significantly.
 *
 * If we need to bring back international phone number parsing & rendering, look at the history of this file
 * around 2023-01-10, which includes the ability to format and parse international phone numbers, as well as
 * detecting the country of origin for those phone numbers using country calling codes.
 *
 * As phone numbers are no longer a critical part of our application, we removed that library to reduce application
 * weight.
 *===================*/

const usNumber = /^(\+\d)?\d{7}(\d{3,})?(x\d+)?$/;
const validNumber = /\+?\d{5,}(x\d+;)?/;

function cleanPhoneNumber(v) {
  if (v && v.length && /\d/.test(v)) {
    return v.replace(/[-\s\.\(\)]+/g, '');
  }
  return v;
}

function formatPhoneNumber(v) {
  let phone = v;
  v = cleanPhoneNumber(v);
  if (usNumber.test(v)) {
    phone = '';
    if (v.length > 10 && v[0] === '+') {
      phone = `+${v[1]} `;
      v = v.slice(2);
    }
    phone += v.replace(
      /^(...)?(...)(....)(x.+)?$/,
      function (m, n1, n2, n3, nExt) {
        let ret = '';
        if (n1) {
          ret += `(${n1}) `;
        }
        ret += `${n2}-${n3}`;
        if (nExt) {
          ret += ` ${nExt}`;
        }
        return ret;
      },
    );
  }
  return phone;
}

function validate(v) {
  return validNumber.test(cleanPhoneNumber(v));
}

export const phoneNumberValidatorComponentModule = angular
  .module('Q.components.forms.phone-number-validator', [
    formGroupMessagesComponentModule,
  ])

  .constant('formatPhoneNumber', formatPhoneNumber)

  .filter('phoneNumber', () => formatPhoneNumber)

  .directive('phoneNumber', function ($parse, FORM_GROUP_MESSAGES) {
    FORM_GROUP_MESSAGES.add(
      'phoneNumber',
      'Please provide a valid phone number.',
    );

    return {
      require: ['ngModel', '?^phoneNumberCountry'],
      link: function (scope, el, attrs, [ngModel, pnCountry]) {
        if (pnCountry) {
          pnCountry.ngModel = ngModel;
        }

        ngModel.$parsers.push(function (value) {
          const cleanedResult = value && cleanPhoneNumber(value);
          return usNumber.test(cleanedResult) ? cleanedResult : value;
        });

        ngModel.$formatters.push(formatPhoneNumber);

        ngModel.$validators.phoneNumber = function (modelValue) {
          // enable soft validations
          if (attrs.phoneNumberEnableInvalid) {
            return true;
          } else {
            return !modelValue || validate(modelValue);
          }
        };

        el.on('blur', function () {
          if (ngModel.$valid) {
            ngModel.$setViewValue(formatPhoneNumber(ngModel.$modelValue));
            ngModel.$render();
          }
        });
      },
    };
  });
